<div class="flex flex-column align-items-center p-1 surface-overlay border-round">
  <span class="font-bold text-2xl block mb-2 mt-4">🎉 Felicidades ya eres usuario seguidor 🎉</span>

  <img width="150px" src="/assets/poli/poli-corazon.png" alt="" />

  <div class="flex gap-3">
    <button (click)="toSocialNetwork('tiktok')" pButton pRipple label="Tiktok" class="p-button-text p-0"></button>
    <button style="color: rgb(19, 131, 211)" (click)="toSocialNetwork('instagram')" pButton pRipple label="Instagram" class="p-button-text p-0"></button>

    <button style="color: rgb(211, 19, 48)" (click)="toSocialNetwork('youtube')" pButton pRipple label="Youtube" class="p-button-text p-0"></button>
  </div>

  <br />

  <p class="mb-0"> Poli esta muy agradecido, ahora tienes acceso a:</p>

  <ul>
    <li>Palabras ilimitadas</li>
    <li>3 conversaciones al día</li>
  </ul>

  <br />
  <p> Recuerda que <b>nuestra versión premium </b> contiene <b>todas</b> las funcionalidades la <b>AI para optimizar</b> tu aprendizaje</p>

  <p>Y tenemos una oferta increible para ti.</p>
  <br />

  <div style="text-align: center">
    <button (click)="openSalesLetter()" class="promo-button"> 🚀 Promoción Prelanzamineto 🎉 antes de 21/Mayo/2025 ⏰🗓️</button>
  </div>

  <br />
</div>
